/* eslint-disable no-trailing-spaces */
import React from 'react';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';

import {
  CONTACTS_TITLE,
  CONTACTS_DESCRIPTION,
} from '../../Utils/Constants/SEO';
import './css/Contacts.css';
import {
  WE_ON_CALL_SHORT,
  CONTACT_TEXT,
  COMPANY_INFO,
  COMPANY_NAME,
  IP,
  ADDRESS,
  REGISTRY_CERTIFICATE,
  PHONE_TEXT,
  EMAIL_TEXT,
  PHONE_NUMBER,
  EMAIL,
  WORK_HOURS,
  CONTACT_US,
  TELEGRAM,
  VIBER,
  INSTAGRAM,
  SUPPORT_HOURS,
  CONSULT_HOURS_DESC,
} from '../../Utils/Constants/GlobalConstants';
import SupportIco from '../../images/support.png';
import ColorLogo from '../../images/color-logo.webp';
import { ReactComponent as Telegram } from '../../images/white-telegram.svg';
import { ReactComponent as Inst } from '../../images/white-insta.svg';
import { ReactComponent as Viber } from '../../images/white-viber.svg';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>{CONTACTS_TITLE}</title>
          <meta name="description" content={CONTACTS_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/contacts/" />
          <meta property="og:title" content={CONTACTS_TITLE} />
          <meta property="og:description" content={CONTACTS_DESCRIPTION} />
          <meta
            property="og:image"
            content="https://tourhunter.by/file/thr_logo.png"
          />

          <link rel="canonical" href="https://tourhunter.by/contacts/" />
        </Helmet>
        <div className="cont_w">
          <div className="containerW">
            <div className="cont_content_w">
              <div className="const_title_w">
                <div>
                  <div className="cont_title_1">{WE_ON_CALL_SHORT}</div>
                  <div className="cont_title_2">{CONTACT_TEXT}</div>
                </div>
                <img alt="" src={SupportIco} className="constact_img" />
              </div>

              <div className="cont_info_w">
                <div className="cont_info_col1">
                  <div className="cont_col11">
                    <div className="contact_info_title mb_20">
                      {COMPANY_INFO}
                    </div>
                    <div className="contact_section_title mb_6">
                      {COMPANY_NAME}
                    </div>
                    <div className="contact_gray_text mb_20">TourHunter</div>
                    <div className="contact_section_title mb_6">{IP}</div>
                    <div className="contact_gray_text mb_20">
                      Новик Наталья Станиславовна УНП 692232544
                    </div>
                    <div className="contact_section_title mb_6">{ADDRESS}</div>
                    <div className="contact_gray_text mb_20">
                      220081, Республика Беларусь, д. Копище, ул. Братьев Райт
                      7, оф. 92
                    </div>
                    <div className="contact_section_title mb_6">
                      {REGISTRY_CERTIFICATE}
                    </div>
                    <div className="contact_gray_text">
                      №692232544, выдано Минским райисполкомом 23.10.2023 г.
                    </div>
                  </div>
                  <div className="cont_col12">
                    <div className="contact_section_title mb_6">
                      {PHONE_TEXT}
                    </div>
                    <div className="contact_gray_text mb_20">
                      {PHONE_NUMBER}
                    </div>
                    <div className="contact_section_title mb_6">
                      {EMAIL_TEXT}
                    </div>
                    <div className="contact_gray_text mb_20">{EMAIL}</div>
                    <div className="contact_section_title mb_6">
                      {WORK_HOURS}
                    </div>
                    <div className="contact_gray_text mb_10">
                      {CONSULT_HOURS_DESC}
                    </div>
                    <div className="contact_gray_text mb_30">
                      {SUPPORT_HOURS}
                    </div>
                    <img className="cont_logo" src={ColorLogo} alt="" />
                  </div>
                </div>
                <div className="cont_info_col2">
                  <div className="contact_info_title mb_20">{CONTACT_US}</div>
                  <div className="cont_social_w">
                    <Link
                      className="const_but"
                      target="_blank"
                      to="https://t.me/tourhunterby"
                    >
                      <Telegram className="const_social_ico" />
                      <div className="wr_text_18">{TELEGRAM}</div>
                    </Link>
                    <Link
                      className="const_but"
                      target="_blank"
                      to="https://www.instagram.com/tourhunter.by"
                    >
                      <Inst className="const_social_ico" />
                      <div className="wr_text_18">{INSTAGRAM}</div>
                    </Link>
                    <Link
                      className="const_but"
                      target="_blank"
                      to="viber://chat?number=%2B375296659965"
                    >
                      <Viber className="const_social_ico" />
                      <div className="wr_text_18">{VIBER}</div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
